import { State } from '../state';

export const TimelineExportSelectors = {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    timelineExportUrl: (state: State) => state.TimelineExport.url,
    timelineExportLoading: (state: State): boolean => state.TimelineExport.loading,
};
